import request from '@/utils/axios.js'

// 获取登记信息
export function getVisitorInfo (data) {
  return request({
    url: '/qrcode/a/mobileAPI/trace/register/info',
    method: 'post',
    data: data
  })
}

// 提交登记信息
export function submitVisitorInfo (data) {
  return request({
    url: '/qrcode/a/mobileAPI/trace/submit',
    method: 'post',
    data: data
  })
}
